// extracted by mini-css-extract-plugin
module.exports = {"accordionButton":"accordionButton__276lc","icon":"icon__uRXdn"};